import React from 'react';

/**
 * Pagination indicator shared by both scroll directions across chat surfaces.
 * Floats over the chat (never in the message flow) so showing/hiding it cannot
 * shift the messages; the bottom edge sits clear of the scroll-to-bottom button.
 */
export const ChatLoadingIndicator: React.FC<{ edge: 'top' | 'bottom' }> = ({ edge }) => (
  <div
    className={`absolute ${edge === 'top' ? 'top-[8px]' : 'bottom-[52px]'} left-1/2 -translate-x-1/2 z-10 pointer-events-none`}
  >
    <div className='flex items-center gap-2 text-sm text-text-tertiary bg-bg-primary border border-border-secondary shadow-shadow-md rounded-full px-3 py-1.5'>
      <div className='animate-spin rounded-full h-4 w-4 border-b-2 border-border-brand'></div>
      <span>Loading more messages...</span>
    </div>
  </div>
);
